import Download from './download';

export default {
  Download,
};
